class FileUpload {
  constructor(el) {
    this.el = el instanceof HTMLElement ? el : document.querySelector(el);
    this.build();

    this.el.addEventListener('change', e => this.update(e));
  }

  build() {
    this.label = document.createElement('label');
    this.label.setAttribute('for', this.el.id);
    this.label.classList.add('Upload');

    this.button = document.createElement('span');
    this.button.textContent = this.el.getAttribute('data-label');
    this.button.className = 'Upload-button Button Button--upload';
    this.label.appendChild(this.button);

    this.value = document.createElement('span');
    this.value.textContent = 'Please select a file...';
    this.value.classList.add('Upload-value');
    this.label.appendChild(this.value);

    this.el.parentNode.insertBefore(this.label, undefined);
  }

  update(e) {
    this.value.textContent = this.el.value.replace(/^.*[\/\\]([^\/\\].*\.[A-Za-z]*)/, '$1');
  }
}

export default FileUpload;



// WEBPACK FOOTER //
// ./scripts/components/fileupload.js